<div class="container-fluid px-4 pb-4">
    <app-outbound-my-score-filter-bar
        title="Post-Production MDT"
        (filtersChanged)="onFiltersChanged($event)"
    ></app-outbound-my-score-filter-bar>

    <app-doughnut-chart-table
        title="Post-Production MDT"
        valueHeader="Trailers"
        [slices]="slices"
        [palette]="palette"
        [score]="totalLoads"
        formatMode="decimal"
        [centerText]="centerText"
    ></app-doughnut-chart-table>

    <div class="card border-0 shadow-sm">
        <div class="card-body">
            <div class="d-sm-flex justify-content-between align-items-center mb-4">
                <h4 class="mb-0 text-secondary">My Score Trending</h4>
                <dx-select-box
                    [items]="groupingOptions"
                    [(value)]="grouping"
                    valueExpr="value"
                    displayExpr="text"
                    stylingMode="filled"
                    [width]="140"
                    (onValueChanged)="onGroupingChanged()"
                ></dx-select-box>
            </div>
            <dx-chart [dataSource]="trendingData">
                <dxi-series argumentField="period" valueField="onTime" name="Loaded On Time" type="bar" [color]="onTimeColor" [barPadding]="0.3"></dxi-series>
                <dxi-series argumentField="period" valueField="late" name="Loaded Late" type="line" [color]="lateColor"></dxi-series>
                <dxi-value-axis [visualRange]="{ startValue: 0, endValue: 100 }" [tickInterval]="20">
                    <dxo-label [customizeText]="percentAxisLabel"></dxo-label>
                </dxi-value-axis>
                <dxo-argument-axis argumentType="datetime">
                    <dxo-label [visible]="true"></dxo-label>
                    <dxo-grid [visible]="false"></dxo-grid>
                    <dxo-tick [visible]="false"></dxo-tick>
                </dxo-argument-axis>
                <dxo-legend [visible]="true" verticalAlignment="bottom" horizontalAlignment="center"></dxo-legend>
                <dxo-tooltip [enabled]="true" [customizeTooltip]="customizeTrendingTooltip"></dxo-tooltip>
            </dx-chart>
        </div>
    </div>
</div>
